import { selectFactory } from '../helpers';

import { APPLICATION_FIELDS, FIELDS } from './constants';

const selectStartPage = ({ startPage }) => {
  return startPage;
};

export const selectField = selectFactory({ selector: selectStartPage });

export const selectError = selectField(FIELDS.ERROR);

const selectApplication = selectField(FIELDS.APPLICATION);
const selectApplicationFields = selectFactory({ selector: selectApplication });

export const selectCarInstanceId = selectApplicationFields([APPLICATION_FIELDS.CAR_INSTANCE, 'id']);
export const selectCustomerId = selectApplicationFields([APPLICATION_FIELDS.CUSTOMER, 'id']);
export const selectWorksheetId = selectApplicationFields(APPLICATION_FIELDS.ID);
